import React, { PureComponent } from 'react';
import { array, object } from 'prop-types';

class StatiscticsGoalsTableItem extends PureComponent {
  static propTypes = {
    data: object.isRequired,
    config: array.isRequired,
    ignored: array.isRequired,
    offer: object.isRequired,
    dict: object.isRequired,
    offers: array.isRequired,
  };

  static defaultProps = {
    data: {},
    config: [],
    ignored: [],
    offer: {},
    dict: {},
    offers: [],
  };

  state = {
    SUB_DATA_ID: 199,
  };

  componentDidMount() {
    const { config } = this.props;
    const cfg = config.find(({ type }) => type === 'sub_data');

    cfg !== undefined &&
      this.setState(() => ({
        SUB_DATA_ID: cfg.id,
      }));
  }

  renderStat = () => {
    const { config, data, ignored } = this.props;

    return (
      <tr>
        {config.map(({ id, isRendering }) =>
          !ignored.includes(id) && isRendering !== false ? <td key={id}>{data[id]}</td> : undefined,
        )}
      </tr>
    );
  };

  renderSubStat = () => {
    const { config, data, offer, dict } = this.props;
    const { SUB_DATA_ID } = this.state;
    const stats = data[SUB_DATA_ID];

    if (stats && stats.length > 0) {
      return stats.map((stat, index) => (
        <tr className="sub-stats" key={index}>
          {config.map(({ id, type, isRendering }) => {
            if (type === 'sub_data' || type === 'offer_id' || isRendering === false) {
              return undefined;
            }

            if (type === 'pixel_id') {
              let pixel;
              if (offer && offer.pixels) {
                pixel = offer.pixels.find(({ id: pixelId }) => pixelId === stat[id]);
              }
              if (!pixel && dict['pixels']) {
                pixel = dict['pixels'].find(({ id: pixelId }) => pixelId === stat[id]);
              }
              return pixel ? <td key={id}>{pixel.title}</td> : <td key={id}>{stat[id]}</td>;
            }

            return <td key={id}>{stat[id]}</td>;
          })}
        </tr>
      ));
    }
  };

  render() {
    return (
      <tbody>
        {this.renderStat()}
        {this.renderSubStat()}
      </tbody>
    );
  }
}

export default StatiscticsGoalsTableItem;
